import { Box, Skeleton, useBreakpointValue } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import MobileNav from './MobileNav';
import BottomTabNavbar from './BottomTabNavbar';

import LeftNav from './LeftNav';
import { useUser, useUserProfile } from '../../../hooks/V2/useUser';
import { useLocation, useNavigate } from 'react-router-dom';

let timeInterval: any;

const CommonWrapper = ({
	children,
	showBottomNav = true,
	showLeftNav = true,
	isPrivate = true,
}: {
	children: React.ReactNode;
	showBottomNav?: boolean;
	showLeftNav?: boolean;
	isPrivate?: boolean;
}) => {
	const location = useLocation();
	const [isLoading, setIsLoading] = useState(false);
	const { data: userProfile, isLoading: userProfileLoading } = useUserProfile();

	// @ts-ignore
	const isResume = window.location.pathname === '/resume' && userProfile?.resumeBuilderUserId;
	const isMobile = useBreakpointValue({ base: true, lg: false });

	return (
		<Box overflow="hidden" maxH="100dvh">
			{<MobileNav />}
			<Box display={showLeftNav ? 'flex' : 'block'} w="full">
				{showLeftNav ? <LeftNav /> : <></>}
				<Skeleton isLoaded={!isLoading} position="relative" w="full" h="calc(100dvh - 56.04px)" overflow="auto" id='scrollDiv'>
					{children}
					{/* <Box mt="64px"></Box> */}
				</Skeleton>
			</Box>
			{showBottomNav && isMobile && !isResume ? <BottomTabNavbar /> : <></>}
		</Box>
	);
};

export default CommonWrapper;
